import React from 'react';
const GamesView = () => <div style={{ padding: 40, fontSize: 24, color: '#1db954', textAlign: 'center' }}>🎮 Games View (Dummy)</div>;
export default GamesView; 